/* PathComponent.js */

"use strict";
// const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./PathRenderer");

class PathComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        this.setPath(newVal);
    }

    getValue() {
        return this.getPath();
    }

    setPath(newVal) {
        this._value = newVal;
        this.emit("PathChange", newVal);
        return this;
    }

    getPath() {
        return this._value;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = PathComponent;
